var map = {
	"./en.json": "edd4",
	"./en_14-10-2024.json": "9ab2",
	"./en_15-09-24.json": "d14b",
	"./en_March.json": "deae",
	"./en_originale.json": "2c44",
	"./it.json": "0825",
	"./it_14-10-2024.json": "81d2",
	"./it_15-09-24.json": "fbdf",
	"./it_March.json": "156e",
	"./it_originale.json": "0776"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";